<template>
<div class="app-wrapper shareholder-wrap">
  <div class="outer-wrap" v-if="metaReady">
  <Logo></Logo>
  <h2 class="shareholder-hd" v-html="get(conferenceMeta, 'login_info.title', '')"></h2>
  <p class="shareholder-explain">사전에 공유 받은 입장 코드를 입력해주세요.</p>
  <div class="input-wrap">
    <label>
      <input type="text" class="input-style01" placeholder="입장 코드" v-model="userAuthCode" @keydown="onKeyDownFromAuthCode">
    </label>
  </div>
  <div class="button-wrap">
    <button type="button" class="btn-confirm" @click="submitAuthCode">확인</button>
  </div>
  </div>
</div>
</template>
<script>
import Logo from '@/pages/conference/components/Logo'
import _ from 'lodash'
import { PATH_NAME_CONFERENCE_LIVE_VIEW } from '@/common/resources/conference.router.const'
import { getConferenceMetaInfo, postAuthenticateCodeWithPreDeployCode } from '@/common/utils/request.conference'
import {
  AUTHENTICATE_LIFE_TIME_MILLISECONDS,
  setAuthCookieForConference,
  setCompanyName
} from '@/pages/conference/js/conference.utils'

export default {
  name: 'AuthFromCodeView',
  components: {
    Logo
  },
  data () {
    return {
      userAuthCode: '',
      conferenceMeta: null,
      metaReady: false
    }
  },
  methods: {
    get: _.get,
    goLivePage () {
      setAuthCookieForConference(AUTHENTICATE_LIFE_TIME_MILLISECONDS)
      setCompanyName('')
      this.$router.push({ name: PATH_NAME_CONFERENCE_LIVE_VIEW })
    },
    onKeyDownFromAuthCode (e) {
      if (e.key === 'Enter' || e.code === 'Enter') {
        e.preventDefault()
        this.submitAuthCode()
      }
    },
    submitAuthCode () {
      if (this.userAuthCode === '') {
        alert('입장 코드를 입력해주세요')
        return
      }
      postAuthenticateCodeWithPreDeployCode(this.userAuthCode).then(({ data }) => {
        const { resultcode, resultmessage } = data
        if ((resultcode === '200' || resultcode === 200) && resultmessage === 'success') {
          this.goLivePage()
        } else if ((resultcode === '551' || resultcode === 551) && resultmessage === 'pass') {
          // for test only start
          // alert(`resultcode : "551" & resultmessage : "pass" 상황입니다.\n 박병주 책임에게 문의해주세요\n 테스트용메세지 이며 운영에 배포되지 않습니다.`)
          // for test only end
          this.goLivePage()
        } else {
          alert(resultmessage)
        }
      })
    },
    init () {
      getConferenceMetaInfo().then((response) => {
        this.conferenceMeta = response
        this.metaReady = true
      })
    }
  },
  created () {
    this.init()
  }
}
</script>
